import axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../../Elements/Icon/Icon';
import PopUp from '../../Elements/PopUp/PopUp';
import './AdminMenu.scss';

export default class AdminMenu extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showMenu: true,
            showConfirmation: false,
            msg: '',
        };
    }

    callManagementApi = (url, action) => {
        const apiCallFunc = axios[action];
        apiCallFunc(url)
            .then((res) =>
                this.setState({
                    msg: res.data.msg,
                    showConfirmation: true,
                    showMenu: false,
                })
            )
            // eslint-disable-next-line no-console
            .catch(console.error);
    };

    renderTitle = () => {
        const title = this.props.contentTitle ? this.props.contentTitle : '';
        const truncatedTitle = title.length > 100 ? `${title.substring(0, 100)}...` : title;
        return (
            <div className="title">{`Manage ${this.props.type}: ${truncatedTitle}`}</div>
        );
    };

    renderMenuItems = () => (
        <ul className="admin-menu">
            {this.renderTitle()}
            {this.props.adminMenu.map((menuItem) => (
                <button
                    type="button"
                    className="link btn btn-outline-primary"
                    key={menuItem.name}
                    onClick={() =>
                        this.callManagementApi(menuItem.url, menuItem.action)
                    }
                    onKeyPress={() =>
                        this.callManagementApi(menuItem.url, menuItem.action)
                    }
                >
                    {menuItem.name}
                </button>
            ))}
            {
                <li className="link btn btn-outline-primary">
                    <a
                        href={this.props.cmsLink}
                        target="_blank"
                        rel="noreferrer"
                    >
                        View In CMS
                    </a>
                </li>
            }
        </ul>
    );

    renderConfirmation = () => (
        <div>
            <div className="title align-items-center p-5">{this.state.msg}</div>
            <div
                className="link text-right underline"
                onClick={() =>
                    this.setState({ showMenu: true, showConfirmation: false })
                }
                onKeyPress={() =>
                    this.setState({ showMenu: true, showConfirmation: false })
                }
                tabIndex={0}
                role="button"
            >
                Back to Menu
            </div>
        </div>
    );

    onClose = () => {
        this.props.closeAdminMenu();
        this.setState({ showMenu: true, showConfirmation: false });
    };

    render() {
        const btn = this.props.showMenuIcon && (
            <div
                className="pt-1 pl-2"
                onClick={this.props.toggleAdminMenu}
                onKeyPress={this.props.toggleAdminMenu}
                tabIndex={0}
                role="button"
            >
                <Icon name="dotdotdot" bgColor="white-bg" size="xsmall" />
            </div>
        );

        return (
            <div className="Admin-menu">
                {btn}
                <PopUp
                    showPopUp={this.props.openAdminMenu}
                    showOverlay
                    cancel={this.onClose}
                    showLogo={false}
                    minWidth="360px"
                    hideCloseButton
                >
                    {this.state.showMenu ? this.renderMenuItems() : null}
                    {this.state.showConfirmation
                        ? this.renderConfirmation()
                        : null}
                </PopUp>
            </div>
        );
    }
}

AdminMenu.propTypes = {
    type: PropTypes.string.isRequired,
    adminMenu: PropTypes.arrayOf(
        PropTypes.shape({
            action: PropTypes.string,
            name: PropTypes.string,
            url: PropTypes.string,
        })
    ),
    cmsLink: PropTypes.string,
    contentTitle: PropTypes.string,
    openAdminMenu: PropTypes.bool.isRequired,
    closeAdminMenu: PropTypes.func.isRequired,
    toggleAdminMenu: PropTypes.func.isRequired,
    showMenuIcon: PropTypes.bool,
};

AdminMenu.defaultProps = {
    adminMenu: [],
    cmsLink: null,
    contentTitle: null,
    showMenuIcon: true,
};
